export const BADGE_COLORS = {
  "Food Novice": "badge-novice",
  "Food Explorer": "badge-explorer",
  "Food Connoisseur": "badge-connoisseur",
  "Prince Foody": "badge-prince",
  "Royal Foody": "badge-royal"
};
